<template>
	<div>
		<!-- Navigation -->
		<section class="mt-n4 mb-1 pb-5">
			<p class="pull-right mb-2 small">
				<button
					:class="blockBtn == false ? '' : 'bg-neutral-300'"
					class="btn btn-primary px-2 py-2 pt-0 pb-1"
					style="font-size: 1rem; font-weight: bold;"
					@click="goToNextStep"
					:disabled="processingApi || $v.$invalid"
				>
					<small> {{ $t("advance") }} </small>
				</button>
			</p>
			<p class="pull-right mr-2">
				<button
					class="btn btn-primary px-2 py-2 pt-0 pb-1"
					style="font-size: 1rem;"
					@click="$emit('prev')"
					:disabled="processingApi"
					v-show="activeStepIndex > 0"
				>
					<small> {{ $t("back") }} </small>
				</button>
			</p>
		</section>

		<!-- Form -->
		<div class="form-group">
			<label
				:class="survey.id == 552 ? 'color-avai' : 'black'"
				class="title-bold"
			>
				{{ $t("registration_country") }}
			</label>
			<div class="error mt-n2" v-if="$v.selectedCountry.$error">
				<span class="error " v-if="!$v.selectedCountry.required">{{
					$t("zip_code") + $t("is_required")
				}}</span>
			</div>

			<div class="country-input">
				<input
					list="countriesSorted"
					class="form-control"
					placeholder="Digite aqui"
					id="selectedCountry"
					v-model="selectedCountry"
				/>
				<datalist id="countriesSorted">
					<option
						class="text-black"
						v-for="(country, index) in countriesSorted"
						:key="index"
					>
						{{ country.country_Name }}
					</option>
				</datalist>
			</div>
		</div>

		<!-- Button -->
		<div v-if="processingApi" class="div-start-survey">
			<h2
				class="title-bold"
				v-text="message"
				style="font-size: 0.95rem; letter-spacing: 0.35px; margin-bottom: -10px; text-transform: uppercase; text-align: center; color: black;"
			></h2>

			<h5
				class="loading"
				style="font-size: 1.25rem; letter-spacing: 0.35px; text-transform: uppercase; text-align: center; color: black;"
			>
				<span
					style="font-size: 1.25rem; letter-spacing: 0.35px; text-transform: uppercase; text-align: center; color: black;"
					class="dot"
					>.</span
				>
				<span
					style="font-size: 1.25rem; letter-spacing: 0.35px; text-transform: uppercase; text-align: center; color: black;"
					class="dot"
					>.</span
				>
				<span
					style="font-size: 1.25rem; letter-spacing: 0.35px; text-transform: uppercase; text-align: center; color: black;"
					class="dot"
					>.</span
				>
			</h5>
		</div>

		<section v-if="!processingApi" class="row">
			<div class="col-12 mt-5 mx-auto col-md-6">
				<button
					:style="
						style.surveyBtnColor
							? { backgroundColor: style.surveyBtnColor }
							: { backgroundColor: style.homeBtnColor }
					"
					type="submit"
					class="w-100 btn btn-primary btn-block my-3"
					@click="goToNextStep"
					:disabled="processingApi || $v.$invalid"
				>
					{{ $t("advance") }}
					<span
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
						v-if="processingApi"
					></span>
				</button>
			</div>
		</section>
	</div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import Navigation from "@/components/registration/components/Navigation";

// Utils
import { utils } from "../../services/Survey.js";
const U = new utils();

import { mask } from "vue-the-mask";

export default {
	name: "SurveyCountry",
	components: {
		Navigation,
	},
	props: {
		profile: {
			type: Object,
			required: true,
		},
		processingApi: {
			type: Boolean,
			required: true,
		},
		activeStepIndex: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		showEnd: false,
		completeForm: false,
		message: "",
		selectedCountry: "",
	}),
	directives: {
		mask,
	},
	validations: {
		selectedCountry: required,
	},
	watch: {
		selectedCountry(newVal) {
			this.updateSelectedCountryId();
			this.SET_SavedCountry(newVal);
		},
	},
	computed: {
		...mapState(["countries", "savedCountry"]),
		style() {
			return this.$store.state.template.style;
		},
		survey() {
			return this.$store.state.template.survey;
		},
		countriesSorted() {
      return this.countries.slice().sort((a, b) => {
        return a.country_Name.localeCompare(b.country_Name, 'pt');
      });
    }
	},
	created() {
		if (this.savedCountry) {
			this.selectedCountry = this.savedCountry;
		}
	},
	mounted() {
		if (this.activeStepIndex !== 0) this.focusOn("selectedCountry");
	},
	methods: {
		...mapMutations(["SET_SavedCountry"]),
		updateSelectedCountryId() {
			const country = this.countries.find(
				(c) => c.country_Name === this.selectedCountry
			);
			if (country) {
				this.profile.Address.Country = country.id;
			}
		},
		focusOn(el) {
			document.getElementById(el).focus();
		},
		goToNextStep() {
			if (this.selectedCountry.length !== 0) {
				if (!this.$v.$invalid) this.$emit("next");
			} else {
				this.$vs.notify({
					color: "RGBA(255,0,0)",
					title: this.$t("registration_country_errors_3"),
					text: "",
					time: 5000,
				});
			}
		},
	},
};
</script>

<style scoped>
.div-start-survey {
	margin-bottom: -15px;
	width: 100%;
	height: 70px;
	margin-top: 20px;
}

.loading {
	font-size: 1.25rem;
	letter-spacing: 0.35px;
	text-transform: uppercase;
	text-align: center;
	color: black;
}

.dot {
	animation: loading 1s infinite steps(1, end);
}

.dot:nth-child(2) {
	animation-delay: 0.2s;
}

.dot:nth-child(3) {
	animation-delay: 0.4s;
}

@keyframes loading {
	0% {
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}
</style>
